<template>
    <div class="HRV">
        <div class="left">
            <div class="item">
                <p class="title"><i><img src="@/assets/Analysissoftware/HRV/ic_Real_wave@2x.png" alt=""></i>实时波</p>
                <div class="chart">
                    <div ref="realTimeWaves" style="width: 100%;height:160px"></div>
                </div>
            </div>
            <div class="item">
                <p class="title" style="background:#FF5733;"><i><img src="@/assets/Analysissoftware/HRV/ic_rate@2x.png" alt=""></i>心率</p>
                <div class="chart">
                    <div ref="heartRateCurve" style="width: 100%;height:160px"></div>
                </div>
            </div>
            <div class="bottom">
                <div class="items">
                    <p class="title"><i><img src="@/assets/Analysissoftware/HRV/ic_arspectrum@2x.png" alt=""></i>AR频谱</p>
                    <div class="chart">
                        <div ref="arSpectrumList" style="width: 100%;height:100%"></div>
                    </div>
                </div>

                <div class="lowfrequency">
                    <p class="title">
                        <i><img src="@/assets/Analysissoftware/HRV/ic_rateheart@2x.png"></i>
                        <span>心率</span>
                    </p>
                    <div class="other">
                        <div class="columnar">
                            <div class="range">
                                <span>0</span>
                                <span>30</span>
                                <span>60</span>
                                <span>90</span>
                                <span>120</span>
                            </div>
                            <div class="bar">
                                <i class="red_bg" :style="{'height':HRVInfo.pulseValue==null?'0':HRVInfo.pulseValue+'%'}"></i>
                            </div>
                        </div>
                        <div class="figure">
                            <p>最大值:<label class="red">{{HRVInfo.hearRateMax}}</label></p>
                            <p>最小值:<label class="yellow">{{HRVInfo.hearRateMin}}</label></p>
                            <p>平均值:<label class="cyan">{{HRVInfo.hearRateAvg}}</label></p>
                            <p style="margin-top: 30px;">脉博值:<label>{{HRVInfo.pulseValue}}</label></p>
                        </div>
                    </div>
                </div>

                <div class="lowfrequency">
                <p class="title">
                    <i><img src="@/assets/Analysissoftware/HRV/ic_press@2x.png"></i>
                    <span>压力</span>
                </p>
                <div class="other">
                    <div class="columnar">
                        <div class="range">
                            <span>0</span>
                            <span>30</span>
                            <span>60</span>
                            <span>90</span>
                            <span>120</span>
                        </div>
                        <div class="bar">
                            <i class="yellow_bg" :style="{'height':HRVInfo.pressureCur==null?'0':HRVInfo.pressureCur+'%'}"></i>
                        </div>
                    </div>
                    <div class="figure">
                        <p>最大值:<label class="red">{{HRVInfo.pressureMax}}</label></p>
                        <p>最小值:<label class="yellow">{{HRVInfo.pressureMin}}</label></p>
                        <p>平均值:<label class="cyan">{{HRVInfo.pressureAvg}}</label></p>
                        <p style="margin-top: 30px;">当前值:<label>{{HRVInfo.pressureCur}}</label></p>
                    </div>
                </div>
            </div>

            </div>
        </div>
        <div class="right">
            <div class="Basicinfor">
                <label class="title">用户基本信息</label>
                <p class="item">部门：{{ HRVInfo.deptName }}</p>
                <p class="item">姓名：{{ HRVInfo.realName }}</p>
                <p class="item">性别：{{ HRVInfo.sex }}</p>
                <p class="item">年龄：{{ HRVInfo.age }}</p>
            </div>

            <div class="lowfrequency">
                <p class="title">
                    <i><img src="@/assets/Analysissoftware/HRV/ic_lf@2x.png"></i>
                    <span>低频(LF%)</span>
                </p>
                <div class="other">
                    <div class="columnar">
                        <div class="range">
                            <span>0</span>
                            <span>30</span>
                            <span>60</span>
                            <span>90</span>
                            <span>120</span>
                        </div>
                        <div class="bar">
                            <i :style="{'height':HRVInfo.balanceScore==null?'0':HRVInfo.balanceScore+'%'}"></i>
                        </div>
                    </div>
                    <div class="figure">
                        <p>高频:<label class="red">{{Math.floor(HRVInfo.hf)}}</label></p>
                        <p>低频:<label class="yellow">{{Math.floor(HRVInfo.lf)}}</label></p>
                        <p>LF/HF:<label class="cyan">{{Math.floor(HRVInfo.lowHighRatio)}}</label></p>
                        <span class="text">交感神经活跃</span>
                        <p>协调分数:<label>{{HRVInfo.balanceScore}}</label></p>
                    </div>
                </div>
            </div>



        </div>
    </div>
</template>
<script>
export default{
    data() {
        return {
            HRVInfo:{},
            userId:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            time:null
        }
    },
    created(){
        this.getHRVInfo()
    },
    mounted() {
        var _this=this;
        setTimeout(() => {
            _this.time=setInterval(() => {
                _this.getHRVInfo();
            }, 1000);
        }, 2000);
    },
    methods: {
        getHRVInfo(){
            this.$Http_Post('/bioassay/soft/getHRVInfo',{userId:this.userId}).then(res=>{
                if(res.Code==0){
                    this.HRVInfo=res.Data;
                    this.realTimeWaves(res.Data.realTimeWaves);
                    this.heartRateCurve(res.Data.heartRateCurve);
                    this.arSpectrumList(res.Data.arSpectrumList);
                    console.log(res.Data);
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 实时波
        realTimeWaves(data){
            let Xdata=[];
            for(let item in data){Xdata.push(item)};
            var myChart = this.$echarts.init(this.$refs.realTimeWaves);
            var option = {
                tooltip: {},
                grid: {
                    top:30,
                    left: 30,  
                    right: 30,
                    bottom:30
                },  
                xAxis: {
                    type: 'category',
                    data: Xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                series:[
                {
                    name:'心率',
                    data: data,
                    type: 'line',
                    smooth: true,
                    color: '#1FA1CC'  
            
                }
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // 心率
        heartRateCurve(data){
            let Xdata=[];
            for(let item in data){Xdata.push(item)};
            var myChart = this.$echarts.init(this.$refs.heartRateCurve);
            var option = {
                tooltip: {},
                grid: {
                    top:30,
                    left: 30,  
                    right: 30,
                    bottom:30
                },  
                xAxis: {
                    type: 'category',
                    data: Xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},  
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},  
                },
                series:[
                {
                    name:'心率',
                    data: data,
                    type: 'line',
                    smooth: true,
                    color: '#1FA1CC'  
            
                }
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // AR频谱
        arSpectrumList(data){
            let Xdata=[];
            for(let item in data){Xdata.push(item)};
            var myChart = this.$echarts.init(this.$refs.arSpectrumList);
            var option = {
                tooltip: {},
                grid: {
                    top:30,
                    left: 30,  
                    right: 30,
                    bottom:30
                },  
                xAxis: {
                    type: 'category',
                    data: Xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                series:[
                {
                    name:'心率',
                    data: data,
                    type: 'line',
                    smooth: true,
                    color: '#1FA1CC'  
            
                }
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        }
    },
    destroyed(){
        clearInterval(this.time);
    }
}
</script>
<style scoped>
img{width: 100%;display:block;}
.HRV{background:#291713;display: flex;min-height: 100%;padding: 15px 0 0;}
.HRV .left{flex: auto;margin:0 10px;}
.HRV .left .item{background: #61463F;padding: 20px 20px;margin: 0 0 10px;}
.HRV .left .item .title{background: #1F3E8C;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.HRV .left .item .title i{width:30px;display: inline-block;margin-right: 5px;}
.HRV .left .item .chart{background: #372C26;}
.HRV .left .bottom{display: flex;}

.HRV .left .bottom .items{flex: auto;background: #34231F;}
.HRV .left .bottom .items .chart{height: 80%;}
.HRV .left .bottom .items .title{background:#1F3E8C;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.HRV .left .bottom .items .title i{width:30px;display: inline-block;margin-right: 5px;}
.HRV .left .bottom .lowfrequency{margin:0 0 0 10px;}
.HRV .right{width:240px;display: inline-block;}
.HRV .lowfrequency{background:rgba(255, 255, 255, 0.05);margin-top:15px;}
.HRV .lowfrequency .title{font-size: 20px;color: #9FE635;display: flex;padding:5px;align-items: center;background:#1F3E8C;}
.HRV .lowfrequency .title i{width:30px;display: inline-block;margin-right: 12px;}
.HRV .lowfrequency .other{display: flex;padding: 15px 0;}
.HRV .right .lowfrequency .other{padding: 33px 0;}
.HRV .lowfrequency .other .columnar{flex: auto;display: flex;}
.HRV .lowfrequency .other .columnar .range{color:#fff;width: 50px;display: flex;flex-direction: column-reverse;justify-content: space-between;}
.HRV .lowfrequency .other .columnar .range span{display: block;text-align: center;}
.HRV .lowfrequency .other .columnar .bar{width: 60px;background: #291713;height: 100%;position: relative;}
.HRV .lowfrequency .other .columnar .bar i{width: 100%;height: 45%;background: #00B2C9;display: block;position: absolute;bottom:0;left:0;transition: all .3s linear;}
.HRV .lowfrequency .other .figure{margin: 0 10px;}
.HRV .lowfrequency .other .figure p{font-size: 14px;background: url('../../../assets/Analysissoftware/HRV/ic_rectangle@2x.png') no-repeat;background-size: 100% 100%;width: 90px;color: #fff;text-align: center;display: flex;align-items: center;justify-content: center;margin-bottom:5px;min-height: 30px;}
.HRV .right .lowfrequency .other .figure p{margin-bottom: 15px;}
.HRV .lowfrequency .other .figure p label{font-size: 22px;}
.HRV .lowfrequency .other .figure .text{color:#FFC300;padding: 5px 0 50px;display: block;}
.HRV .right .Basicinfor{background:url("../../../assets/Analysissoftware/bg_personal@2x.png") no-repeat;height:360px;background-size: 100% 100%;width: 240px;}
.HRV .right .Basicinfor .title{font-size: 22px;color: #fff;display: block;text-align: right;padding:5px 20px 20px 0;}
.HRV .right .Basicinfor .item{font-size: 18px;color: #43B8D9;padding: 15px 0 0 20px;}
.HRV .right .startBtn{width: 100%;margin: 10px 0;}
.red{color: #FF5733;}
.yellow{color: #E3C21B;}
.red_bg{background: #FF5733!important;}
.yellow_bg{background: #E3C21B!important;}
.cyan{color: #00BAAD;}
</style>